import React from 'react';
import PropTypes from 'prop-types';

const Slider = ({ 
  children, 
  title,
  className = "",
  ...props 
}) => {
  return (
    <div className={`w-full ${className}`} {...props}>
      <div className="bg-global-4 rounded-[20px] p-4 sm:p-5 lg:p-6">
        {title && (
          <h2 className="text-lg sm:text-xl lg:text-[24px] font-svn-gilroy font-bold leading-[26px] text-global-text2 mb-4 sm:mb-5 lg:mb-[14px] ml-4">
            {title}
          </h2>
        )}
        
        <div className="flex flex-row flex-nowrap gap-3 sm:gap-4 lg:gap-[12px] overflow-x-auto md:overflow-x-visible">
          {children}
        </div>
      </div>
    </div>
  );
};

Slider.propTypes = {
  children: PropTypes?.node,
  title: PropTypes?.string,
  className: PropTypes?.string,
};

export default Slider;